import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getTherapistPatientsPainQueryKey = () => ["getTherapistPatientsPain"] as const;

export const useGetTherapistPatientsPain = () => {
  const client = useApiClient();

  return useQuery(getTherapistPatientsPainQueryKey(), () => client.getTherapistPatientsPain());
};
